/** Template language rows grouped by PDF intake section (Document Authoring Tool_Forms_17June2026). */

export const POPULATION_TEMPLATE_LANGUAGE_ROWS = [
  {
    key: 'definitions_childbearing_potential',
    label: '5.4.1 Definitions Related to Childbearing Potential',
    placeholder: 'Assembled verbatim from Patient Library selections above',
    readOnlyAssembled: true,
  },
  {
    key: 'contraception_requirements',
    label: '5.4.2 Contraception Requirements',
    placeholder: 'Assembled verbatim from Patient Library selections above',
    readOnlyAssembled: true,
  },
];

export const ADVERSE_EVENTS_TEMPLATE_LANGUAGE_ROWS = [
  {
    key: 'definition_adverse_event',
    label: '9.1.1 Definition of Adverse Event',
    placeholder: 'Define adverse events for the trial',
  },
  {
    key: 'definition_serious_adverse_event',
    label: '9.1.2 Definition of Serious Adverse Event',
    placeholder: 'Define serious adverse events for the trial',
  },
  {
    key: 'definitions_product_complaints',
    label: '9.1.3 Definitions of Product Complaints',
    placeholder: 'Define product complaints for the trial',
  },
  {
    key: 'ae_reporting_timing_procedures',
    label: '9.2 Timing and Procedures for Collection and Reporting',
    placeholder: 'Describe timing and procedures for collection and reporting',
  },
  {
    key: 'ae_reporting_timing',
    label: '9.2.1 Timing',
    placeholder: 'Describe AE/SAE collection timing',
  },
  {
    key: 'ae_reporting_collection_procedure',
    label: '9.2.2 Collection procedure',
    placeholder: 'Describe collection procedures for AEs/SAEs',
  },
  {
    key: 'ae_reporting_reporting',
    label: '9.2.3 Reporting',
    placeholder: 'Describe reporting procedures for AEs/SAEs',
  },
  {
    key: 'ae_reporting_special_interest',
    label: '9.2.4 Adverse events of special interest',
    placeholder: 'Describe adverse events of special interest',
  },
  {
    key: 'ae_reporting_disease_related_events',
    label: '9.2.5 Disease-related Events or Outcomes Not Qualifying as AEs or SAEs',
    placeholder: 'Describe disease-related events not qualifying as AEs or SAEs',
  },
  {
    key: 'pregnancy_postpartum_information',
    label: '9.3 Pregnancy and Postpartum Information',
    placeholder: 'Describe pregnancy and postpartum information requirements',
  },
  {
    key: 'special_safety_situations',
    label: '9.4 Special Safety Situations',
    placeholder: 'Describe special safety situations and procedures',
  },
  {
    key: 'comments',
    label: 'Additional Notes',
    placeholder: 'Enter any additional notes for this section',
    notesOnly: true,
  },
];

export const DISCONTINUATION_TEMPLATE_LANGUAGE_ROWS = [
  {
    key: 'permanent_discontinuation_trial_intervention',
    label: '7.1.1 Permanent Discontinuation of Trial Intervention',
    placeholder: 'Describe permanent discontinuation of trial intervention',
  },
  {
    key: 'temporary_discontinuation_trial_intervention',
    label: '7.1.2 Temporary Discontinuation of Trial Intervention',
    placeholder: 'Assembled from Section 7.1.2 decision tree / protocol-source generation above',
    readOnlyAssembled: true,
  },
  {
    key: 'rechallenge',
    label: '7.1.3 Rechallenge',
    placeholder: 'Assembled from Section 7.1.3 decision tree / protocol-source generation above',
    readOnlyAssembled: true,
  },
  {
    key: 'participant_discontinuation_withdrawal',
    label: '7.2 Participant Discontinuation or Withdrawal from the Trial',
    placeholder: 'Describe participant discontinuation or withdrawal from the trial',
  },
  {
    key: 'management_loss_to_followup',
    label: '7.3 Management of Loss to Follow-Up',
    placeholder: 'Describe management of loss to follow-up',
  },
  {
    key: 'additional_information',
    label: 'Additional Notes',
    placeholder: 'Enter any additional notes for this section',
    notesOnly: true,
  },
];

export const DISCONTINUATION_TEMPLATE_FIELD_KEYS = DISCONTINUATION_TEMPLATE_LANGUAGE_ROWS
  .filter((r) => !r.notesOnly)
  .map((r) => r.key);

export const ADVERSE_EVENTS_TEMPLATE_FIELD_KEYS = ADVERSE_EVENTS_TEMPLATE_LANGUAGE_ROWS
  .filter((r) => !r.notesOnly)
  .map((r) => r.key);

/**
 * Section 11 template language table titles — matches clinical intake regulatory template fields.
 * One row per intake checkbox field (no duplicate 11.2.x / 11.4 / 11.9 variants).
 */
export const REGULATORY_TEMPLATE_LANGUAGE_TITLES = [
  '11.1 Regulatory and Ethical Considerations',
  '11.2.1 Investigators Responsibilities',
  '11.2.2 Sponsor Responsibilities',
  '11.3.1 Informed Consent for Rescreening',
  '11.3.2 Informed Consent for Use of Remaining Samples in Exploratory Research',
  '11.4 Committees',
  '11.5 Insurance and Indemnity',
  '11.6 Risk-Based Quality Management',
  '11.7 Data Governance',
  '11.8 Data Protection',
  '11.9 Source Reports',
  '11.10 Protocol Deviations',
  '11.11 Early Site Closure',
  '11.12 Data Dissemination',
];

/** Table title → base text key in templateLanguageUpdatedBase when they differ. */
export const TEMPLATE_LANGUAGE_BASE_TITLE_ALIASES = {
  '11.3.1 Informed Consent for Rescreening': '11.3 Informed Consent Process',
  '11.3.2 Informed Consent for Use of Remaining Samples in Exploratory Research':
    '11.3 Informed Consent Process',
};

export const ALL_TEMPLATE_LANGUAGE_FIELD_KEYS = [
  ...POPULATION_TEMPLATE_LANGUAGE_ROWS,
  ...ADVERSE_EVENTS_TEMPLATE_LANGUAGE_ROWS,
].map((r) => r.key);
